import { get } from "lodash";
import { createSelector } from "reselect";

const dataIndexQuery = state => get(state, "connections.dataIndex", null);
const dataMapQuery = state => get(state, "connections.dataMap", null);

const selectProjectConnections = createSelector(
  [dataIndexQuery, dataMapQuery],
  (dataIndex, dataMap) => {
    if (!dataIndex || !dataMap) return [];

    return dataIndex.map(id => {
      return dataMap[id];
    });
  }
);

const connectionsSelector = {
  selectProjectConnections
};

export default connectionsSelector;
